import React from "react";
import { useSnackbar } from '../../../../context/snackbar-context';
import SimpleConfirmationDialog from "../../../SimpleConfirmationDialog";
import request from "../../../../util/SuperagentUtils";
import { adminBookingsReportEndpoints } from "../../../../requests/api-endpoints";
import { ReportDialogProps } from "../../../../interfaces";
import { AdminBookingReportVO } from "../../../../types/model/valueObject/booking/AdminBookingReportVO";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../../../util/NetworkErrorUtil";

const cannedMessages = {
  genericError: 'Unable to toggle overages. Please contact support.',
  success: (orderNumber: string) => `Successfully toggled overages for booking ${orderNumber}.`
};

const ToggleChargeOveragesDialog = ({
  item,
  open,
  onClose
}: ReportDialogProps<AdminBookingReportVO>) => {
  const { snackbarShowMessage } = useSnackbar();

  const handleConfirm = () => {
    if (!item) {
      snackbarShowMessage(cannedMessages.genericError, 'error');
      onClose({item, action: 'ERROR'});
      return;
    }
    request.post(adminBookingsReportEndpoints.actions.toggleOverages)
      .send({ bookingId: item.id })
      .then(() => {
          snackbarShowMessage(cannedMessages.success(item.orderNumber), 'success');
          onClose({item, action: 'SUCCESS'});
      }).catch((err: any) => snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(err), 'error'));
  };

  return (
    <SimpleConfirmationDialog
      title={'Toggle Overages'}
      body={`Toggle overages for ${item?.orderNumber}?`}
      open={open && Boolean(item)}
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  );
};

export { ToggleChargeOveragesDialog };